import dateFormatter from './date_formatter';

/**
 * Returns raw Html version of DateTimeFormatter component.
 * @param params
 * @param services
 * @returns {String}
 */
export default function dateTimeFormatter(params, services = {}) {
  return dateFormatter({dateOnly: false, ...params}, services);
}
